import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'isophi-info-popup',
  templateUrl: './info-popup.component.html',
  styleUrls: ['./info-popup.component.scss'],
  standalone: false,
})
export class InfoPopupComponent {
  @Input() title = '';
  @Input() continueLabel = '';
  @Input() showDontShowAgain = true;
  @Input() dontShowAgain = false;
  @Output() dontShowAgainChange = new EventEmitter<boolean>();
  @Output() closed = new EventEmitter<void>();

  onCheckboxChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.dontShowAgain = checked;
    this.dontShowAgainChange.emit(checked);
  }

  onContinue(): void {
    this.closed.emit();
  }
}
